import React from 'react'
import { AppModal, AppButton } from '@/shared/ui'
import { withTranslation } from 'react-i18next'
import './styles.less'

const ModalInactive = ({ showModal, setShowModal, timeout = 0, t: copy }) => {
  return (
    <div>
      <AppModal className='modal-inactive-container' centered open={showModal} footer={null}>
        <h4>{copy('scenes.inactive_modal_title')}</h4>
        <p>{copy('scenes.inactive_modal', { timeout })}</p>
        <div className='button-container'>
          <AppButton key='ok' variant='primary' onClick={() => setShowModal(false)}>
            {copy('scenes.button_ok', { timeout })}
          </AppButton>
        </div>
      </AppModal>
    </div>
  )
}

export default withTranslation()(ModalInactive)
